import React from 'react';

import { PrimaryButton } from '@crehana/ui/';

import { TextField } from '@crehana/ui';

import { useTranslation } from '@crehana/i18n';

import InputGuestUser from 'Jsx/CheckoutV4/shared/InputGuestUser';
import LegalCheckbox from 'Jsx/CheckoutV4/components/LegalCheckbox';
import PaymentsLoader from 'Jsx/CheckoutV4/shared/PaymentsLoader';
import CardIssuerLogo from 'Jsx/Shared/CardIssuerLogo';

import NewsLetterCheckbox from 'Jsx/CheckoutV4/components/NewsLetterCheckbox';

import { PayuFormProps } from '../../../../Stripe/types';

const Form: React.FunctionComponent<PayuFormProps> = ({
  creditCardDigitsWithBlankSpaces,
  creditCardNumberErrorMessage,
  creditCardNumber,
  isCreditCardNumberValid,
  loader,
  creditCardIssuer,
  creditCardExpiry,
  creditCardExpiryErrorMessage,
  isCreditCardExpiryValid,
  creditCardCVV,
  isCreditCardCVVValid,
  creditCardCVVDigits,
  creditCardCVVErrorMessage,
  isPaymentButtonActive,
  paymentError,
  onBlurCreditCardNumber,
  onChangeCreditCardNumber,
  onChageCreditCardExpiry,
  onBlurCreditCardExpiry,
  onChangeCreditCardCVV,
  onBlurCVV,
  onClickPay,
  onEmailChange,
  guestEmail,
  onChangeFullName,
  onBlurFullName,
  fullName,
  fullNameErrorMessage,
  isFullNameValid,
  identityDocument,
  identityDocumentErrorMessage,
  isIdentityDocumentValid,
  onChangeIdentityDocument,
  onBlurIdentityDocument,
  onChangePhoneNumber,
  onBlurPhoneNumber,
  phoneNumber,
  phoneNumberErrorMessage,
  isPhoneNumberValid,
  isGuestCheckout,
  checkedTerms,
  setCheckedTerms,
  isMembership,
  creditCardNumberFocus,
  creditCardExpiryFocus,
  creditCardCVVFocus,
  identityDocumentFocus,
  fullNameFocus,
  checkedNewsLetterTerms,
  setCheckedNewsLetterTerms,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <form
        autoComplete="off"
        style={{ maxWidth: '400px' }}
        onSubmit={event => {
          event.preventDefault();
          if (isPaymentButtonActive) {
            onClickPay();
          }
        }}
      >
        {isGuestCheckout && (
          <div className="w-full mb-16">
            <InputGuestUser
              // @ts-expect-error
              onEmailChange={onEmailChange}
              guestEmail={guestEmail}
              emailLabel="Correo electrónico"
            />
          </div>
        )}
        <div className="relative block w-full mt-8 mb-16">
          <TextField
            type="tel"
            maxLength={creditCardDigitsWithBlankSpaces}
            id="creditCardNumber"
            name="creditCardNumber"
            data-cy="creditCardNumber"
            full
            onChange={onChangeCreditCardNumber}
            value={creditCardNumber}
            errorText={creditCardNumberErrorMessage}
            error={creditCardNumberErrorMessage !== ''}
            check={isCreditCardNumberValid}
            disabled={loader}
            onBlur={onBlurCreditCardNumber}
            endAdornment={<CardIssuerLogo cardType={creditCardIssuer} />}
            autoFocus={creditCardNumberFocus}
            label={t('CARD_NUMBER_LABEL')}
          />
        </div>

        <div className="flex justify-between w-full mt-16 mb-16 flex-start">
          <div style={{ width: '43%' }}>
            <TextField
              id="creditCardExpiry"
              className="cardDetails"
              name="creditCardExpiry"
              data-cy="cardDate"
              full
              errorText={creditCardExpiryErrorMessage}
              onChange={onChageCreditCardExpiry}
              maxLength={5}
              error={creditCardExpiryErrorMessage !== ''}
              value={creditCardExpiry}
              check={isCreditCardExpiryValid}
              disabled={loader}
              onBlur={onBlurCreditCardExpiry}
              type="tel"
              autoFocus={creditCardExpiryFocus}
              label={t('EXPIRATION_DATE_LABEL')}
            />
          </div>
          <div style={{ width: '50%' }}>
            <TextField
              type="tel"
              id="creditCardCVV"
              name="creditCardCVV"
              data-cy="cardCvv"
              className="cardDetails"
              full
              errorText={creditCardCVVErrorMessage}
              onChange={onChangeCreditCardCVV}
              maxLength={creditCardCVVDigits}
              value={creditCardCVV}
              error={creditCardCVVErrorMessage !== ''}
              check={isCreditCardCVVValid}
              disabled={loader}
              onBlur={onBlurCVV}
              autoFocus={creditCardCVVFocus}
              label={t('CVC_CVV_LABEL')}
            />
          </div>
        </div>
        <div className="relative block w-full mt-8 mb-16">
          <TextField
            type="tel"
            maxLength={8}
            id="identityDocument"
            name="identityDocument"
            data-cy="identityDocument"
            full
            onChange={onChangeIdentityDocument}
            onBlur={onBlurIdentityDocument}
            value={identityDocument}
            errorText={identityDocumentErrorMessage}
            error={identityDocumentErrorMessage !== ''}
            check={isIdentityDocumentValid}
            disabled={loader}
            autoFocus={identityDocumentFocus}
            label={t('IDENTITY_DOCUMENT_LABEL')}
          />
        </div>
        <div className="relative block w-full mt-8 mb-16">
          <TextField
            type="text"
            maxLength={40}
            id="fullName"
            name="fullName"
            data-cy="fullName"
            full
            onChange={onChangeFullName}
            value={fullName}
            errorText={fullNameErrorMessage}
            error={fullNameErrorMessage !== ''}
            check={isFullNameValid}
            disabled={loader}
            onBlur={onBlurFullName}
            autoFocus={fullNameFocus}
            label={t('CARD_HOLDER_LABEL')}
          />
        </div>
        <div className="mb-16">
          <TextField
            type="tel"
            maxLength={9}
            id="phoneNumber"
            name="phoneNumber"
            data-testid="phone-number-field"
            full
            onChange={onChangePhoneNumber}
            onBlur={onBlurPhoneNumber}
            value={phoneNumber}
            errorText={phoneNumberErrorMessage}
            error={phoneNumberErrorMessage !== ''}
            check={isPhoneNumberValid}
            disabled={loader}
            startAdornment={<span className="font-body3">+51</span>}
            label={t('PHONE_NUMBER_LABEL')}
          />
        </div>
        <LegalCheckbox
          className="mb-24"
          checkedTerms={checkedTerms}
          setCheckedTerms={setCheckedTerms}
          isMembership={isMembership}
        />
        <NewsLetterCheckbox
          className="mb-24"
          checkedNewsLetterTerms={checkedNewsLetterTerms}
          setCheckedNewsLetterTerms={setCheckedNewsLetterTerms}
        />

        <div className="w-full sm:max-w-280">
          <PrimaryButton
            isAccent
            disabled={!isPaymentButtonActive}
            data-cy="stripeSubmit"
            type="submit"
            full
            size="xl"
            label={t('BUY_NOW')}
          />
        </div>
        {paymentError && (
          <p className="mt-8 font-legals text-red-main" data-cy="paymentError">
            {paymentError}
          </p>
        )}
        <div id="mylistID" />
      </form>
      {loader && (
        <PaymentsLoader type="purchaseOnline" cardType={creditCardIssuer} />
      )}
    </div>
  );
};

export default Form;
